import React, { Component } from 'react';
import { connect } from 'react-redux';
import AuthView from 'components/AuthView';
import Smart from 'components/Smart';
import { selectScooter } from 'actions';
import {
    fetchAllScooters,
    updateDocumentTitle,
    clearSingleScooter,
    fetchOperationUsers,
    clearAllScooters,
} from 'actions';
import FilterBar, {
    FILTER_SERVICE,
    FILTER_RENTAL_STATE,
    FILTER_BATTERY,
    FILTER_TRACKER_SOC,
    FILTER_MAIN_TYPE,
    FILTER_SUB_TYPE,
    FILTER_MODEL,
    FILTER_CITY,
    FILTER_SCOOTER_TICKET,
    FILTER_VIP_SCOOTER,
} from 'view/ScooterList/FilterBar';
import MapView from './MapView';
import { importFilterShortcutScooterMapPayload } from 'hooks/useFilterShortcut';
import './scooter-map.scss';

export const DEFAULT_SCOOTER_MAP_PAYLOAD = {
    plate: undefined,
    filter: {
        [FILTER_SERVICE]: undefined,
        [FILTER_RENTAL_STATE]: undefined,
        [FILTER_BATTERY]: undefined,
        [FILTER_TRACKER_SOC]: undefined,
        [FILTER_MAIN_TYPE]: undefined,
        [FILTER_SUB_TYPE]: undefined,
        [FILTER_MODEL]: undefined,
        [FILTER_CITY]: undefined,
        [FILTER_SCOOTER_TICKET]: undefined,
        [FILTER_VIP_SCOOTER]: undefined,
    },
};

class ScooterMap extends Component {

    constructor(props) {
        super(props);

        this.state = {
            resetBounds: 0,
            queryPayload: {
                plate: undefined,
                filter: {
                    ...DEFAULT_SCOOTER_MAP_PAYLOAD.filter,
                },
            }
        };
    }

    componentDidMount() {
        const { dispatch, location, history } = this.props;
        const { pathname, state: locationState } = location;
        dispatch(fetchOperationUsers());
        dispatch(updateDocumentTitle(`routes.${ pathname }`));

        // from other route
        importFilterShortcutScooterMapPayload(
            history,
            locationState,
            this
        );
    }
    componentDidUpdate(prevProps) {
        const { location: prevLocation, history } = prevProps;
        const { location } = this.props;
        const { state: locationState } = location;
        // keep filtering on same route
        if (locationState && prevLocation.state !== locationState) {
            importFilterShortcutScooterMapPayload(
                history,
                locationState,
                this,
                this.fetchScooterList,
            );
        }
    }

    componentWillUnmount() {
        const { dispatch } = this.props;
        dispatch(clearSingleScooter());
    }

    handleSubmit = value => {
        this.setState({
            queryPayload: {
                plate: value === '' ? undefined : value,
                filter: {}
            }
        }, () => {
            this.fetchScooterList(true);
            this.forceUpdate();
        });
    }

    fetchScooterList = (isResetBounds = false) => {
        const { dispatch } = this.props;
        const { queryPayload } = this.state;
        const { filter, ...params } = queryPayload;

        dispatch(clearAllScooters());
        return dispatch(fetchAllScooters({
            ...filter,
            ...params,
        })).then(() => {
            let { resetBounds } = this.state;

            if (isResetBounds) {
                resetBounds = Date.now();
            }

            this.setState({
                resetBounds,
            });
        });
    }

    handleFilterOn = (type, value) => {
        const { queryPayload } = this.state;
        const { filter } = queryPayload;
        const { dispatch } = this.props;

        switch (type) {
        case FILTER_SERVICE:
        case FILTER_RENTAL_STATE:
        case FILTER_MAIN_TYPE:
        case FILTER_SUB_TYPE:
        case FILTER_MODEL:
        case FILTER_CITY:
        case FILTER_VIP_SCOOTER:
        case FILTER_SCOOTER_TICKET:
            filter[type] = value.inputSelect;
            break;
        case FILTER_BATTERY:
        case FILTER_TRACKER_SOC:
            filter[`${type}_from`] = value.from;
            filter[`${type}_to`] = value.to;
            break;
        default:
        };

        // rebind
        this.setState((prevState) => ({
            queryPayload: {
                ...prevState.queryPayload,
                filter
            }
        }), () => {
            dispatch(selectScooter([]));
            this.fetchScooterList(true);
            this.forceUpdate();
        });

    }

    render() {
        const { resetBounds, queryPayload } = this.state;

        return (
            <AuthView className="scooter-map">
                <FilterBar
                    defaultSettings={ queryPayload }
                    onChange={ this.handleFilterOn }
                    onSubmit={ this.handleSubmit }
                />
                <Smart
                    fetch={ this.fetchScooterList }
                    refreshTime={ 0 }
                    pauseRefresh={ true }
                    tag=""
                    seamless
                >
                    <MapView
                        onFetch={ this.fetchScooterList }
                        resetBounds={ resetBounds }
                    />
                </Smart>
            </AuthView>
        );
    }
}

export default connect(state => ({
    i18n: state.i18n,
}))(ScooterMap);
